const { default: styled } = require('styled-components');

const NavArrow = styled.input.attrs({ type: 'image' })`
  outline: none;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
`;

export default NavArrow;
